// extracted by mini-css-extract-plugin
export default {"container":"BillingResultList_container__KZNRe","section":"BillingResultList_section__wh-F0"};